<template>
  <div class="address-bar" :class="{ 'with-image': showConfirmation }">
    <div class="container bar-content">
      <div class="phase-interact">
        <transition name="change-text" mode="out-in">
          <div v-if="showBackButton" class="back-button" @click="goBack">
            <icon icon="arrow-left-long-solid" size="sm" />
            <span class="label"> Terug </span>
          </div>
        </transition>
        <transition name="change-text" mode="out-in">
          <h1 key="Jouw situatie">
            {{ label }}
          </h1>
        </transition>
      </div>

      <transition name="change-label" mode="out-in">
        <span v-if="secure" class="secure-label">
          <span> Beveiligd</span>
          <icon icon="x-fa-lock" size="sm" />
        </span>
      </transition>

      <transition name="change-label" mode="in-out">
        <img v-if="showConfirmation" height="170" width="213" class="confirmation-image" :src="alexImage">
      </transition>
    </div>
  </div>
</template>

<script>
import Icon from '../../../vue-elements/icon/Icon.vue';
import alexImage from '../../../../web/assets/people/alex-image-thumbs-up.png';

export default {
  components: { Icon },
  props: {
    label: {
      type: String,
      default: 'Energie vergelijken',
    },
    secure: Boolean,
    nativeBackFunction: {
      type: Boolean,
      default: false,
    },
    showConfirmation: {
      type: Boolean,
      default: false,
    },
    showBackButton: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    onBoardPageURI() {
      return window.history.state && window.history.state.uri
        ? window.history.state.uri
        : false;
    },
    alexImage() {
      return alexImage;
    },
  },
  mounted() {
    this.bootstrapGoBackFooter();
  },
  methods: {
    goBack() {
      // Popstate to trigger the headless renderer.
      if (this.nativeBackFunction) {
        window.history.back();
        return;
      }
      if (this.$route.name === 'wizard' && this.onBoardPageURI) {
        window.history.pushState({}, '', `/${this.onBoardPageURI}`);
        window.dispatchEvent(new Event('popstate'));
      } else if (this.$route.name === 'wizard') {
        window.location.pathname = '/';
      } else if (this.$route.name === 'compare') {
        this.$router.push({ name: 'wizard' });
      } else if (this.$route.name === 'form') {
        this.$router.push({ name: 'compare' });
      }
    },
    bootstrapGoBackFooter() {
      const footerLogoElement = document.querySelector('footer img.main-logo');
      if (footerLogoElement) {
        footerLogoElement.parentElement.addEventListener('click', () => {
          this.goBack();
        });
      }
    },
  },

};
</script>

<style lang="scss" scoped>
@use "assets/scss/_helpers/display";
@use "assets/scss/_variables/colors";
@use "assets/scss/_helpers/breakpoint";

.change-label-leave-active,
.change-label-enter-active,
.change-text-enter-active,
.change-text-leave-active {
  transition-property: opacity;
  transition-duration: 0.4s;
  transition-timing-function: ease;
}

.change-label-enter-active {
  transition-delay: 0.4s;
}

.change-label-enter,
.change-label-leave-to,
.change-text-enter,
.change-text-leave-to {
  opacity: 0;
}

.address-bar {
  padding: 12px 16px;
  background: colors.$block-blue-100;
  color: #fff;
  position: relative;
  //z-index to animate behind navbar-sub
  z-index: 1;

  @include breakpoint.up(md) {
    padding: 16px;
  }

  &.with-image {
    padding-bottom: 0;
    flex-direction: column;

    h1 {
      font-size: 24px;

      @include breakpoint.down(sm) {
        margin-top: 32px;
      }
    }

    .bar-content {
      flex-direction: column;

      @include breakpoint.up(md) {
        flex-direction: row;
        justify-content: space-between;
      }
    }

    .confirmation-image {
      height: 128px;
      width: auto;
    }
  }

  .bar-content {
    @include display.flex-row-between();

    @include breakpoint.up(md) {
      @include display.flex-row-start();
    }
  }

  .phase-interact {
    @include display.flex-row-between();
  }

  .back-button {
    @include display.flex-row-start();

    font-size: 15px;
    padding-right: 16px;
    border-right: 1px solid #fff;
    margin-right: 16px;
    cursor: pointer;

    .icon-element {
      background-color: #fff;
      margin-right: 10px;
    }
  }

  .label {
    @include breakpoint.down(md) {
      display: none;
    }
  }

  h1 {
    margin: 0;
    font-size: 18px;
    line-height: 28px;
    font-weight: 600;

    @include breakpoint.up(sm) {
      font-size: 22px;
      line-height: 36px
    }
  }

  .secure-label {
    @include display.flex-row-between;

    padding: 4px 8px;
    border-radius: 5px;
    background-color: colors.$link-base-default;
    color: colors.$text-light;
    margin-left: 16px;
    line-height: 20px;
    font-weight: 600;
    font-size: 14px;

    @include breakpoint.up(md) {
      padding: 8px 12px;
      line-height: 20px;
      font-size: 15px;
    }

    .icon-element {
      background-color: colors.$text-light;
      margin-left: 8px;
    }
  }
}
</style>
